import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

export default function createEmotionCache() {
    let insertionPoint;

    if (typeof document !== "undefined") {
        insertionPoint =
            document.querySelector('meta[name="emotion-insertion-point"]') ??
            undefined;
    }

    return createCache({
        key: "muirtl",
        insertionPoint,
        stylisPlugins: [prefixer, rtlPlugin],
        speedy: false,
    });
}
